/**
 * @generated SignedSource<<86dc5e86db503541b7f5f8e8ebf49c9f>>
 * @relayHash c2eda27528b76c2e59fa6715f1ef7937
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff7bed3c9ec8bd4c6e9992262f839b04344f618d7b61aa543014997f33d1d3b4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggListQuery$variables = {
  cypherQuery: string;
  first: number;
  isEnabled: boolean;
  queryContext: string;
};
export type AggListQuery$data = {
  readonly graphStore?: {
    readonly cypherQueryV2: {
      readonly " $fragmentSpreads": FragmentRefs<"generateListFromCypher">;
    };
  } | null;
};
export type AggListQuery = {
  response: AggListQuery$data;
  variables: AggListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "cypherQuery"
  },
  {
    "kind": "Variable",
    "name": "queryContext",
    "variableName": "queryContext"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "value"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "GraphStoreCypherQueryV2TimestampObject"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "title"
},
v11 = [
  {
    "kind": "ScalarField",
    "name": "webUi"
  },
  {
    "kind": "ScalarField",
    "name": "base"
  }
],
v12 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v11/*: any*/)
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "concreteType": "ConfluenceSpaceLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v11/*: any*/)
},
v15 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v17 = {
  "kind": "ScalarField",
  "name": "favoritedAt"
},
v18 = {
  "kind": "ScalarField",
  "name": "isFavorite"
},
v19 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      (v18/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "confluenceItemActions_favoritedUpdatable"
      },
      {
        "kind": "InlineDataFragmentSpread",
        "name": "confluenceItemActions_favorited",
        "selections": [
          (v18/*: any*/)
        ],
        "argumentDefinitions": ([]/*: any*/)
      }
    ]
  }
],
v20 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v22 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v11/*: any*/)
},
v23 = {
  "concreteType": "ConfluenceWhiteboardLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v11/*: any*/)
},
v24 = {
  "concreteType": "ConfluenceContentVersion",
  "kind": "LinkedField",
  "name": "latestVersion",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ]
},
v25 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v19/*: any*/)
},
v26 = {
  "concreteType": "ConfluenceDatabaseLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v11/*: any*/)
},
v27 = {
  "kind": "ScalarField",
  "name": "url"
},
v28 = [
  (v9/*: any*/)
],
v29 = {
  "concreteType": "TownsquareIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": (v28/*: any*/)
},
v30 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v31 = {
  "alias": "projectState",
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v35 = [
  (v33/*: any*/),
  (v34/*: any*/)
],
v36 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v37 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v38 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/)
  ]
},
v39 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStarred_extension"
    }
  ]
},
v40 = {
  "alias": "goalState",
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v30/*: any*/)
},
v41 = [
  (v9/*: any*/),
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  (v27/*: any*/),
  {
    "kind": "ScalarField",
    "name": "status"
  },
  {
    "kind": "ScalarField",
    "name": "lastUpdate"
  },
  {
    "concreteType": "ExternalUser",
    "kind": "LinkedField",
    "name": "owners",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "userId"
      }
    ]
  }
],
v42 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/),
    (v9/*: any*/)
  ]
},
v43 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      (v18/*: any*/),
      (v5/*: any*/)
    ]
  }
],
v44 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v43/*: any*/)
},
v45 = [
  (v33/*: any*/),
  (v34/*: any*/),
  (v9/*: any*/)
],
v46 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v13/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v9/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "generateListFromCypher",
                    "selections": [
                      {
                        "concreteType": "GraphStoreCypherQueryV2Edge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreCypherQueryV2Column",
                                "kind": "LinkedField",
                                "name": "columns",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluencePageItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v10/*: any*/),
                                                      (v12/*: any*/),
                                                      (v15/*: any*/),
                                                      (v16/*: any*/),
                                                      {
                                                        "concreteType": "ConfluencePageViewerSummary",
                                                        "kind": "LinkedField",
                                                        "name": "viewer",
                                                        "plural": false,
                                                        "selections": (v19/*: any*/)
                                                      },
                                                      (v20/*: any*/),
                                                      (v21/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluencePage"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceBlogPostItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v10/*: any*/),
                                                      (v22/*: any*/),
                                                      (v15/*: any*/),
                                                      (v16/*: any*/),
                                                      {
                                                        "concreteType": "ConfluenceBlogPostViewerSummary",
                                                        "kind": "LinkedField",
                                                        "name": "viewer",
                                                        "plural": false,
                                                        "selections": (v19/*: any*/)
                                                      },
                                                      (v20/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceBlogPost"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceWhiteboardItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v10/*: any*/),
                                                      (v23/*: any*/),
                                                      (v15/*: any*/),
                                                      (v24/*: any*/),
                                                      (v25/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceWhiteboard"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceDatabaseItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v10/*: any*/),
                                                      (v26/*: any*/),
                                                      (v15/*: any*/),
                                                      (v24/*: any*/),
                                                      (v25/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceDatabase"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateTownsquareProjectItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v13/*: any*/),
                                                      (v27/*: any*/),
                                                      (v29/*: any*/),
                                                      (v31/*: any*/),
                                                      {
                                                        "alias": "projectUpdates",
                                                        "args": (v32/*: any*/),
                                                        "concreteType": "TownsquareProjectUpdateConnection",
                                                        "kind": "LinkedField",
                                                        "name": "updates",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareProjectUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "TownsquareProjectUpdate",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v35/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "updates(first:1)"
                                                      },
                                                      (v38/*: any*/),
                                                      (v39/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "TownsquareProject"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateTownsquareGoalItem",
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      (v13/*: any*/),
                                                      (v27/*: any*/),
                                                      (v40/*: any*/),
                                                      {
                                                        "alias": "goalUpdates",
                                                        "args": (v32/*: any*/),
                                                        "concreteType": "TownsquareGoalUpdateConnection",
                                                        "kind": "LinkedField",
                                                        "name": "updates",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareGoalUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "TownsquareGoalUpdate",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v35/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "updates(first:1)"
                                                      },
                                                      (v38/*: any*/),
                                                      (v39/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "TownsquareGoal"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateExternalPullRequestItem",
                                                    "selections": (v41/*: any*/),
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ExternalPullRequest"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "GraphStoreCypherQueryV2AriNode"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "argumentDefinitions": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphStoreCypherQueryV2Node",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreCypherQueryV2Column",
                            "kind": "LinkedField",
                            "name": "columns",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v12/*: any*/),
                                              (v42/*: any*/),
                                              (v16/*: any*/),
                                              {
                                                "concreteType": "ConfluencePageViewerSummary",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": (v43/*: any*/)
                                              },
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "type": "ConfluencePage"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v22/*: any*/),
                                              (v42/*: any*/),
                                              (v16/*: any*/),
                                              {
                                                "concreteType": "ConfluenceBlogPostViewerSummary",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": (v43/*: any*/)
                                              },
                                              (v20/*: any*/)
                                            ],
                                            "type": "ConfluenceBlogPost"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v23/*: any*/),
                                              (v42/*: any*/),
                                              (v24/*: any*/),
                                              (v44/*: any*/)
                                            ],
                                            "type": "ConfluenceWhiteboard"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v26/*: any*/),
                                              (v42/*: any*/),
                                              (v24/*: any*/),
                                              (v44/*: any*/)
                                            ],
                                            "type": "ConfluenceDatabase"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v13/*: any*/),
                                              (v27/*: any*/),
                                              (v29/*: any*/),
                                              (v31/*: any*/),
                                              {
                                                "alias": "projectUpdates",
                                                "args": (v32/*: any*/),
                                                "concreteType": "TownsquareProjectUpdateConnection",
                                                "kind": "LinkedField",
                                                "name": "updates",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareProjectUpdateEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareProjectUpdate",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v45/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "updates(first:1)"
                                              },
                                              (v46/*: any*/),
                                              (v39/*: any*/)
                                            ],
                                            "type": "TownsquareProject"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              (v13/*: any*/),
                                              (v27/*: any*/),
                                              (v40/*: any*/),
                                              {
                                                "alias": "goalUpdates",
                                                "args": (v32/*: any*/),
                                                "concreteType": "TownsquareGoalUpdateConnection",
                                                "kind": "LinkedField",
                                                "name": "updates",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareGoalUpdate",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v45/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "updates(first:1)"
                                              },
                                              (v46/*: any*/),
                                              (v39/*: any*/)
                                            ],
                                            "type": "TownsquareGoal"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v41/*: any*/),
                                            "type": "ExternalPullRequest"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "AppUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "AtlassianAccountUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "CustomerUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsFeatureFlag"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsOperationsComponentDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsOperationsIncidentDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsProjectDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsPullRequestDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsRepository"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "JiraAutodevJob"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "JiraConfluenceRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "JiraCustomRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "JiraIssueRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "JiraWebRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "TeamType"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v28/*: any*/),
                                            "type": "ThirdPartyUser"
                                          }
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ],
                                    "type": "GraphStoreCypherQueryV2AriNode"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c2eda27528b76c2e59fa6715f1ef7937",
    "id": "ff7bed3c9ec8bd4c6e9992262f839b04344f618d7b61aa543014997f33d1d3b4",
    "metadata": {},
    "name": "AggListQuery",
    "operationKind": "query",
    "text": "query AggListQuery(\n  $cypherQuery: String!\n  $queryContext: String!\n  $isEnabled: Boolean!\n  $first: Int!\n) {\n  graphStore @include(if: $isEnabled) @optIn(to: \"GraphStore\") {\n    cypherQueryV2(query: $cypherQuery, queryContext: $queryContext, first: $first) @optIn(to: \"GraphStoreCypherQueryV2\") {\n      ...generateListFromCypher\n    }\n  }\n}\n\nfragment confluenceItemActions_favorited on ConfluenceFavoritedSummary {\n  isFavorite\n}\n\nfragment generateConfluenceBlogPostItem on ConfluenceBlogPost {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  createdAt\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n  metadata {\n    titleEmojiPublished {\n      value\n    }\n  }\n}\n\nfragment generateConfluenceDatabaseItem on ConfluenceDatabase {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  latestVersion {\n    createdAt\n  }\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n}\n\nfragment generateConfluencePageItem on ConfluencePage {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  createdAt\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n  metadata {\n    titleEmojiPublished {\n      value\n    }\n  }\n  subtype\n}\n\nfragment generateConfluenceWhiteboardItem on ConfluenceWhiteboard {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  latestVersion {\n    createdAt\n  }\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n}\n\nfragment generateExternalPullRequestItem on ExternalPullRequest {\n  id\n  displayName\n  url\n  status\n  lastUpdate\n  owners {\n    userId\n  }\n}\n\nfragment generateListFromCypher on GraphStoreCypherQueryV2Connection {\n  edges {\n    node {\n      columns {\n        value {\n          __typename\n          ... on GraphStoreCypherQueryV2TimestampObject {\n            value\n          }\n          ... on GraphStoreCypherQueryV2AriNode {\n            data {\n              __typename\n              ... on ConfluencePage {\n                __typename\n                ...generateConfluencePageItem\n              }\n              ... on ConfluenceBlogPost {\n                __typename\n                ...generateConfluenceBlogPostItem\n              }\n              ... on ConfluenceWhiteboard {\n                __typename\n                ...generateConfluenceWhiteboardItem\n              }\n              ... on ConfluenceDatabase {\n                __typename\n                ...generateConfluenceDatabaseItem\n              }\n              ... on TownsquareProject {\n                __typename\n                ...generateTownsquareProjectItem\n              }\n              ... on TownsquareGoal {\n                __typename\n                ...generateTownsquareGoalItem\n              }\n              ... on ExternalPullRequest {\n                __typename\n                ...generateExternalPullRequestItem\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on AppUser {\n                id\n              }\n              ... on AtlassianAccountUser {\n                id\n              }\n              ... on CustomerUser {\n                id\n              }\n              ... on DevOpsFeatureFlag {\n                id\n              }\n              ... on DevOpsOperationsComponentDetails {\n                id\n              }\n              ... on DevOpsOperationsIncidentDetails {\n                id\n              }\n              ... on DevOpsOperationsPostIncidentReviewDetails {\n                id\n              }\n              ... on DevOpsProjectDetails {\n                id\n              }\n              ... on DevOpsPullRequestDetails {\n                id\n              }\n              ... on DevOpsRepository {\n                id\n              }\n              ... on DevOpsSecurityVulnerabilityDetails {\n                id\n              }\n              ... on JiraAutodevJob {\n                id\n              }\n              ... on JiraConfluenceRemoteIssueLink {\n                id\n              }\n              ... on JiraCustomRemoteIssueLink {\n                id\n              }\n              ... on JiraIssueRemoteIssueLink {\n                id\n              }\n              ... on JiraWebRemoteIssueLink {\n                id\n              }\n              ... on TeamType {\n                id\n              }\n              ... on ThirdPartyUser {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment generateTownsquareGoalItem on TownsquareGoal {\n  id\n  name\n  url\n  goalState: state {\n    value\n    label\n  }\n  goalUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        creationDate\n        editDate\n        id\n      }\n    }\n  }\n  owner {\n    __typename\n    name\n    accountId\n    accountStatus\n    id\n  }\n}\n\nfragment generateTownsquareProjectItem on TownsquareProject {\n  id\n  name\n  url\n  icon {\n    id\n  }\n  projectState: state {\n    value\n    label\n  }\n  projectUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        creationDate\n        editDate\n        id\n      }\n    }\n  }\n  owner {\n    __typename\n    name\n    accountId\n    accountStatus\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1e1a66be32d4fe6d37befe153f52057";

export default node;
